<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="$router.push('/farms/farms/create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('common_words.add_new_record') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameFarmSelected"
            :visible.sync="modals.read"
            width="80%"
            top="2%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card mb-3" v-if="rowData">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <div ref="map" class="map" style="height: 400px"></div>
                </div>
                <div class="col-md-6">
                  <div class="card-body">
                    <h5 class="card-title">
                      <strong>{{ $t('common_words.code') }}</strong>
                      {{ rowData.code }}
                    </h5>
                    <hr />
                    <p class="card-text mb-2" v-if="rowData.crop">
                      <strong>{{ $t('common_words.farm_size_ha') }}:</strong>
                      {{ rowData.area }}
                    </p>
                    <p class="card-text mb-2" v-if="rowData.crop">
                      <strong>{{ $t('common_words.crop') }}:</strong>
                      {{ rowData.crop.name }} -
                      {{ rowData.cropType.name }}
                    </p>
                    <p class="card-text mb-2" v-else>
                      <strong>{{ $t('common_words.crop') }}:</strong>
                      {{ $t('common_words.no_assigned') }}
                    </p>
                    <p class="card-text mb-2">
                      <strong>{{ $t('production.scales') }}:</strong>
                      <span
                        v-for="(devices, index) in rowData.devices"
                        :key="index"
                      >
                        <span v-if="index != 0">,</span>
                        {{ devices.name }}
                      </span>
                    </p>
                    <p class="card-text mb-2">
                      <strong
                        >{{ $t('common_words.associated_companies') }}:</strong
                      >
                      <span
                        v-for="(business, index) in rowData.businesses"
                        :key="index"
                      >
                        <span v-if="index != 0">,</span>
                        {{ business.name }}
                      </span>
                    </p>
                    <p class="card-text mb-2">
                      <strong
                        >{{ $t('common_words.notification_email') }}:</strong
                      >
                      {{ rowData.email_notification }}
                    </p>
                    <p class="card-text mb-2">
                      <strong>{{ $t('common_words.address') }}:</strong><br />{{
                        rowData.zip_code ? `${rowData.zip_code} - ` : ''
                      }}{{ rowData.city }}, {{ rowData.state }} -
                      {{ rowData.country }};
                      {{ rowData.address }}
                    </p>
                    <p class="card-text mb-2" v-if="rowData.district">
                      <strong>{{ $t('common_words.location') }}:</strong>
                      {{ rowData.district.name }}
                    </p>
                    <p class="card-text mb-2" v-else>
                      <strong>{{ $t('common_words.location') }}:</strong>
                      {{ $t('common_words.no_assigned') }}
                    </p>
                    <p class="card-text mb-2">
                      <small class="text-muted"
                        >{{ $t('common_words.geo_position') }}: Lat:
                        {{ rowData.latitude }} - Lon: {{ rowData.longitude }} -
                        Alt: {{ rowData.altitude }}
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <table class="table text-center">
              <caption></caption>
              <tbody v-if="rowData">
                <tr v-for="blocks in rowData.blocks" :key="blocks.id">
                  <th scope="row">
                    <el-tag type="info"
                      >{{ $t('common_words.name') }} {{ blocks.name }}</el-tag
                    >
                  </th>
                  <td class="text-left">
                    <span v-for="lots in blocks.lots" :key="lots.name">
                      <el-tag type="info" style="height: auto; width: 230px">
                        {{ $t('common_words.name') }} : {{ lots.name }} <br />
                        {{ $t('common_words.area') }}: {{ lots.area }} <br />{{
                          $t('common_words.variety')
                        }}
                        :
                        {{
                          lots.cropVariety
                            ? lots.cropVariety.name
                            : $t('common_words.no_assignment')
                        }}
                        <br />{{ $t('common_words.soil_type') }}:
                        <span style="text-transform: capitalize">{{
                          lots.soil_type_id
                            ? lots.soil_type.name
                            : $t('common_words.none')
                        }}</span>
                        <br />{{ $t('common_words.population') }}:
                        {{
                          lots.population
                            ? lots.population
                            : $t('common_words.none')
                        }}
                      </el-tag>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="card-footer footer-date-at" v-if="rowData">
              <p class="text-muted">
                <small
                  >{{ $t('common_words.created_on') }}
                  {{ rowData.created_at }}</small
                >
              </p>
            </div>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <card-header
            @searchedQuery="searchedQuery"
            class="mr-3 mt-4"
          ></card-header>
          <master-table
            :infoTable="queriedData"
            :columns="tableColumns"
            :showColumnStatus="true"
            :widthColumnStatus="120"
            :indexColumn="{ show: true, fixed: false }"
          >
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow() || isUpdate() || isDelete()"
                @handleView="handleView"
                @handleEdit="handleEdit"
                @handleDelete="handleDelete"
                @handleActivate="handleActivate"
                :canDisable="true"
                :minWidth="110"
              />
            </template>
          </master-table>
        </div>
        <not-index-permissions v-else />
        <card-footer ref="cardfooter" />
        <export-tables
          :pdf="{
            filename: `${$t('common_words.farms')}.pdf`,
            route: 'farms/farms/pdf',
          }"
          :xls="{
            filename: `${$t('common_words.farms')}.excel`,
            route: 'farms/farms/excel',
          }"
        />
        <br />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import configTable from './farm-table';
import Fuse from 'fuse.js';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from '../../../../i18n';

export default {
  components: {
    LPagination,
  },
  computed: {
    ...configTable().Search,
  },
  data() {
    return {
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      farmForm: {
        name: null,
      },
      farmFormEdit: {
        name: null,
      },
      modelValidations: {
        nombre: {
          required: true,
        },
      },
      pagination: {},
      tableColumns: [],
      modals: {
        read: false,
        delete: false,
      },
      searchQuery: '',
      tableData: [],
      nameFarmSelected: 'Fincas',
      rowData: null,
      fuseSearch: null,
      map: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      this.modals[name] = true;
    },

    closeModal(name) {
      this.modals[name] = false;
    },

    handleActivate(_, row) {
      this.farmForm = row;
      SweetAlert.default(
        `${i18n.t('common_words.farm_activate')} "${this.farmForm.name}?`,

        null,
        i18n.t('common_words.accept'),
        1
      ).then((result) => {
        if (result.value) this.activateFarm();
      });
    },

    activateFarm() {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        Axios.updateMaster({
          route: 'farms/farms/activate',
          id: this.farmForm.id,
        })
          .then((response) => this.modifyTable(1, this.farmForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },

    handleView(_, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.nameFarmSelected = ` ${i18n.t('common_words.farm')}: ${
        this.rowData.name
      }`;
      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;
      this.modals['read'] = true;

      this.loadBaseMap(this.rowData.id);
    },

    handleEdit(_, row) {
      row.url_path_form = '/farms/farms/edit';
      this.farmForm = Object.assign({}, row);
      sessionStorage.setItem('editForm', JSON.stringify(this.farmForm));
      this.$router.push({
        path: '/farms/farms/edit',
      });
    },

    handleDelete(_, row) {
      this.farmForm = row;
      SweetAlert.disable(
        `${i18n.t('common_words.farm_deactivate')} <br/>"${this.farmForm.name}"`
      ).then((result) => {
        if (result.value) this.deleteFarm();
      });
    },

    deleteFarm() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.farmForm.route = 'farms/farms';
        Axios.destroyMaster(this.farmForm)
          .then((response) => this.modifyTable(1, this.farmForm.id, response))
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },
    setupTable() {
      const { Table } = configTable();
      // Assign the Table and Search objects to your data properties
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);
      Axios.getMasters('farms/farms')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((column) => {
              return column.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('farms');
  },

  destroyed() {
    this.deselectedItemOnMenu('farms');
  },
};
</script>
<style></style>
